<template>
  <LISAButton
    v-if="'default' in $slots"
    v-bind="{
      ...$attrs,
      onClick: undefined,
      onclick: undefined,
      'data-testid': `${$attrs['data-testid']}`,
    }"
    :label="label"
    :disabled="disabled"
    @click="handleOpenDialog"
  >
    <slot></slot>
  </LISAButton>
  <LISAButton
    v-else
    v-bind="{
      ...$attrs,
      onClick: undefined,
      onclick: undefined,
      'data-testid': `${$attrs['data-testid']}`,
    }"
    :label="label"
    color="warning"
    :disabled="disabled"
    @click="handleOpenDialog"
  />
  <Popover ref="op">
    <div class="flex flex-column align-items-center justify-content-center">
      <div style="max-width: 400px; text-align: center">
        <slot name="label">
          <label>{{ label || t("components.ConfirmationModal.title") }}</label>
        </slot>
      </div>
    </div>
    <div class="flex gap-2 align-items-center justify-content-end mt-4">
      <LISAButton
        :severity="buttons?.cancel?.severity || 'secondary'"
        :icon="buttons?.cancel?.icon || 'fas fa-times'"
        :label="buttons?.cancel?.label || t('global.cancel')"
        v-bind="{
          'data-testid': `${$attrs['data-testid']}-cancel`,
        }"
        @click="op?.hide"
      ></LISAButton>
      <LISAButton
        v-bind="{
          'data-testid': `${$attrs['data-testid']}-submit`,
        }"
        :loading="buttons?.submit?.loading || false"
        :severity="buttons?.submit?.severity || 'success'"
        :icon="buttons?.submit?.icon || 'fas fa-chevron-right'"
        :label="buttons?.submit?.label || t('global.next')"
        @click="handleClick"
      ></LISAButton>
    </div>
  </Popover>
</template>

<script setup lang="ts">
import { useTranslation } from "@/language/translation";

import Popover from "primevue/popover";
import { ref } from "vue";
import LISAButton from "./LISAButton.vue";

const props = defineProps<{
  disabled?: boolean;
  label?: string;
  skip?: boolean;
  buttons?: {
    cancel?: {
      label?: string;
      icon?: string;
      severity?: string;
    };
    submit?: {
      label?: string;
      icon?: string;
      severity?: string;
      loading?: boolean;
    };
  };
}>();
const emit = defineEmits<{
  click: [];
}>();

defineOptions({
  inheritAttrs: false,
});

const op = ref<InstanceType<typeof Popover>>();
function handleOpenDialog(e: MouseEvent) {
  if (props.skip === true) {
    handleClick();
    return;
  }
  op.value?.show(e);
}

function handleClick() {
  if (props.disabled) {
    return;
  }
  op.value?.hide();
  emit("click");
}

const { t } = useTranslation();
</script>
